interface TimeRulerProps {
  hours: number[];
  employeeColumnWidth?: number;
}

export function TimeRuler({ hours, employeeColumnWidth = 200 }: TimeRulerProps) {
  return (
    <div
      className="
        flex border-b border-gray-200 dark:border-gray-700
        bg-surface-muted dark:bg-gray-800 text-[10px] text-ink-muted dark:text-text-light
        select-none
      "
    >
      <div className="shrink-0" style={{ width: employeeColumnWidth }} />
      <div className="relative flex-1 h-6">
        {hours.map((h, i) => {
          const left = (i / (hours.length - 1)) * 100;
          return (
            <div
              key={h}
              className="absolute top-0 bottom-0 flex items-center text-tabular"
              style={{ left: `${left}%`, transform: 'translateX(-50%)' }}
            >
              <span className={h === 12 ? 'font-semibold text-ink dark:text-white' : ''}>
                {String(h).padStart(2, '0')}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
